import React from "react";
import CloseIcon from "@material-ui/icons/Close";
export function GDPRPopup({ handleGDPRPolicy, acceptCookies }) {
  return (
    <></>
  );
}